import * as React from "react"
import { batch } from "@preact/signals-react"
import { Skeleton } from "@mui/material"
import { ModalSeeker } from "@ui-seeker/core"

import { useHistorical } from "./@hooks"
import { openDetails, rowSelected, historicalDataRowClick } from "./@signals"
import HistoricalTable from "./HistoricalTable"


export default function HistoricalModal() {
    const { reportName } = historicalDataRowClick.value

    const { historicalData, isLoadingHistorical } = useHistorical()

    const controller = () => batch(() => {
        rowSelected.value = {}
        openDetails.value = false
        historicalDataRowClick.value = {}
    })
    
    return <ModalSeeker 
        isOpen={openDetails.value} 
        controller={controller} size="md" 
        hideActions 
        title={`${reportName} Historical Execution`}
    >
        {
            isLoadingHistorical  
                ? <Skeleton variant="rectangular" height={300} />
                : <HistoricalTable data={historicalData}/>
        } 
    </ModalSeeker>
}